document.addEventListener('DOMContentLoaded', () => {
  initVariantMetafieldTabs();
});

document.addEventListener('variant:changed', (event) => {
  updateVariantMetafieldTabs(event.detail.variant);
});

function initVariantMetafieldTabs() {
  // No-op on load — server-rendered Liquid already shows the correct
  // selected_or_first_available_variant content. This just confirms
  // listeners are ready for subsequent changes.
}

function updateVariantMetafieldTabs(variant) {
  if (!variant) return;

  document.querySelectorAll('.js-variant-metafield-store').forEach((store) => {
    const blockId = store.dataset.blockId;
    const target = document.querySelector(
      `.js-variant-metafield-content[data-block-id="${blockId}"]`
    );
    if (!target) return;

    const source = store.querySelector(
      `.js-variant-metafield-source[data-variant-id="${variant.id}"]`
    );

    target.innerHTML = source ? source.innerHTML : '';
  });
}